<template>
    <div class="container flex flex-direction">
        <a :href="`/digitize/all${xiangmu_id ? `?xiangmu_id=${xiangmu_id}` : ''}`"
           style="position: fixed;top: 20px;left: 20px;width: 150px;height: 40px;text-align: center;line-height: 40px;background: rgba(255,255,255,.2);color: #fff;font-size: 20px;border-radius: 10px;">返回</a>
        <dv-loading v-if="loading" class="loading">Loading...</dv-loading>
        <div class="page-title self-center">首华·双暖为老志愿服务实时数据</div>
        <div class="total-container flex">
            <div class="title">实时数据</div>
            <div class="number-item flex-sub flex align-center justify-center padding-lr-sm">
                <img class="icon" src="../../../assets/img/data/icon_real_time_1.png">
                <div class="flex flex-direction align-center margin-left-sm">
                    <div class="flex align-end">
                        <dv-digital-flop :config="{style:style,number:[totle_num],content:'{nt}'}"
                                         class="number"/>
                        <div class="label margin-left-xs">次</div>
                    </div>
                    <div class="label max margin-top-xs">服务总数</div>
                </div>
            </div>
            <div class="number-item flex-sub flex align-center justify-center padding-lr-sm">
                <img class="icon" src="../../../assets/img/data/icon_real_time_2.png">
                <div class="flex flex-direction align-center margin-left-sm">
                    <div class="flex align-end">
                        <dv-digital-flop :config="{style:style,number:[ban_num],content:'{nt}'}"
                                         class="number"/>
                        <div class="label margin-left-xs">次</div>
                    </div>
                    <div class="label max margin-top-xs">搬</div>
                </div>
            </div>
            <div class="number-item flex-sub flex align-center justify-center padding-lr-sm">
                <img class="icon" src="../../../assets/img/data/icon_real_time_3.png">
                <div class="flex flex-direction align-center margin-left-sm">
                    <div class="flex align-end">
                        <dv-digital-flop :config="{style:style,number:[sao_num],content:'{nt}'}"
                                         class="number"/>
                        <div class="label margin-left-xs">次</div>
                    </div>
                    <div class="label max margin-top-xs">扫</div>
                </div>
            </div>
            <div class="number-item flex-sub flex align-center justify-center padding-lr-sm">
                <img class="icon" src="../../../assets/img/data/icon_real_time_4.png">
                <div class="flex flex-direction align-center margin-left-sm">
                    <div class="flex align-end">
                        <dv-digital-flop :config="{style:style,number:[huan_num],content:'{nt}'}"
                                         class="number"/>
                        <div class="label margin-left-xs">次</div>
                    </div>
                    <div class="label max margin-top-xs">换</div>
                </div>
            </div>
            <div class="number-item flex-sub flex align-center justify-center padding-lr-sm">
                <img class="icon" src="../../../assets/img/data/icon_real_time_4.png">
                <div class="flex flex-direction align-center margin-left-sm">
                    <div class="flex align-end">
                        <dv-digital-flop :config="{style:style,number:[100],content:'{nt}'}"
                                         class="number"/>
                        <!--                      manyi_lv-->
                        <div class="label margin-left-xs">%</div>
                    </div>
                    <div class="label max margin-top-xs">居民满意度</div>
                </div>
            </div>
        </div>
        <div class="flex-sub flex margin-top-sm">
            <dv-border-box-10 :color="['#fa9d1b','yellow']" backgroundColor="transparent" class="title-container flex-sub">
                <div id="up_echarts" class="echarts padding-sm"></div>
            </dv-border-box-10>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import {serviceRealTimeData} from "@/api/weilao";

export default {
    name: "real_time",
    components: {},
    data() {
        var serverTypex = (index) => {
            switch (index) {
                case 0:
                    return '搬'
                case 1:
                    return '扫'
                case 2:
                    return '换'
                case 3:
                    return '总'
            }
        }
        return {
            xiangmu_id:'',
            style: {
                fontSize: 36,
                fill: '#fbbd00',
                fontFamily: 'PingFang SC',
                fontWeight: 'bold'
            },
            up_option: {
                animationDuration: 2000,
                animationEasing: 'cubicOut',
                color: ["#ffa0a0", "#ff4adb", "#38e6e5", "#ffc919",],
                tooltip: {
                    trigger: 'axis',
                    formatter: function (c) {
                        let str = '';
                        let temp = {
                            bgcricle: '',//颜色
                            seriesName: "", //name
                            valueData: '',//value
                            spacespan: '',
                        };
                        c.forEach((item, index) => {
                            // 做的事情
                            temp.bgcricle = item.marker;
                            temp.seriesName = item.name;
                            temp.seriesType = serverTypex(index);
                            temp.valueData = item.value + '次';
                            temp.spacespan = '<span style="display:inline-block;margin: 0 4px;">:</span>';
                            str += temp.bgcricle + temp.seriesName + ' ' + temp.seriesType + temp.spacespan + temp.valueData + '<br />'
                        })
                        return str
                    }
                },
                legend: {
                    icon: 'rect',
                    itemWidth: 25,
                    itemHeight: 5,
                    itemGap: 20,
                    left: '50px',
                    top: '0px',
                    textStyle: {
                        fontSize: 14,
                        color: '#fff'
                    },
                },
                grid: {
                    left: '10px',
                    right: '20px',
                    bottom: '0%',
                    containLabel: true
                },
                xAxis: {
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#fff',
                            width: 5,
                        }
                    },
                    type: 'category',
                    axisLabel: {
                        fontSize: 10
                    },
                    data: []
                },
                yAxis: {
                    type: 'value',
                    minInterval: 1,
                    splitLine: {
                        show: true, //去除刻度线
                        lineStyle: {
                            color: '#fff',
                            type: 'dotted',
                            dashOffset: 2
                        }
                    },
                    axisTick: {
                        show: false //去除刻度线
                    },
                    axisLine: {
                        show: false, //去除轴线
                        lineStyle: {
                            color: '#fff',
                        }
                    },
                },
                series: []
            },
            ban_num: 0,
            sao_num: 0,
            huan_num: 0,
            manyi_lv: 0,

            totle_num: 0,
        }
    },
    mounted() {
        this.xiangmu_id = this.$route.query.xiangmu_id
        this.init()
    },
    methods: {

        async init() {
            let up_echarts = echarts.init(document.getElementById('up_echarts'))
            const res = await serviceRealTimeData(this.xiangmu_id)
            this.ban_num = res.data.ban_num
            this.huan_num = res.data.huan_num
            this.manyi_lv = res.data.manyi_lv
            this.sao_num = res.data.sao_num
            this.totle_num = res.data.totle_num
            let _date = [], _ban = [], _sao = [], _huan = [], _totle = []
            res.data.every_day_data.map(item => {
                _date.push(item.date)
                _ban.push(item.ban_num)
                _sao.push(item.sao_num)
                _huan.push(item.huan_num)
                _totle.push(item.totle_num)
            })

            this.up_option.xAxis.data = _date
            let data = [{name: "搬", data: _ban}, {name: "扫", data: _sao}, {name: "换", data: _huan}, {
                name: "总",
                data: _totle
            }]
            data.map(item => {
                item.type = 'line'
            })
            this.up_option.series = data
            up_echarts.setOption(this.up_option)
        },

    }
}
</script>

<style lang="scss" scoped>
.container {
    background: url(../../../assets/img/data/bg_data.jpg) no-repeat top;
    background-size: 100% 100%;
    height: 1080px;
    width: 1920px;
    overflow: hidden;
    padding: 0 35px 30px;

    .loading {
        color: #ffffff;
        position: fixed;
    }

    .page-title {
        font-size: 36px;
        line-height: 36px;
        color: transparent;
        -webkit-background-clip: text;
        background-image: linear-gradient(0deg,
            #ffd800 0%,
            #ffec83 50%,
            #ffffff 100%);
        background-blend-mode: normal, normal;
        margin-top: 25px;
        font-weight: bold;
    }

    .total-container {
        height: 121px;
        background-color: #ffffff88;
        box-shadow: inset 0px 83px 150px 0px #c33c0d;
        border: solid 1px #fa9d1b;
        margin-top: 35px;

        .title {
            font-size: 20px;
            writing-mode: vertical-lr;
            text-align: center;
            line-height: 53px;
            color: #ffffff;
            width: 53px;
            height: 121px;
            background-image: linear-gradient(
                    #c63c0d,
                    #c63c0d),
            linear-gradient(
                    #000000,
                    #000000);
            background-blend-mode: normal,
            normal;
            box-shadow: inset 0px 0px 10px 0px #ec8914;
            border: solid 2px #fa9d1b;
        }

        .number-item {
            .label {
                font-size: 14px;
                color: #ffffff;

                &.max {
                    font-size: 16px;
                }
            }

            .icon {
                width: 63px;
                height: 63px;
            }

            .number {
                height: 36px;
            }
        }

    }

    .title-container {
        .border-box-content {
            position: relative;
        }

        .years {
            position: absolute;
            right: 20px;
            top: 50px;
            width: 96px;
            height: 26px;
            line-height: 26px;
            border-radius: 15px;
            border: solid 1px #ffffff;
            text-align: center;
            color: #FFFFFF;
        }

        .bg-title {
            z-index: 99;
            width: 556px;
            text-align: center;
            height: 44px;
            line-height: 44px;
            position: absolute;
            background: url(../../../assets/img/data/bg_title.png) no-repeat top;
            background-size: 100% auto;
            left: 50%;
            transform: translateX(-50%);

            .title {
                line-height: 44px;
                font-size: 24px;
                color: transparent;
                -webkit-background-clip: text;
                background-image: linear-gradient(0deg,
                    #ffd800 0%,
                    #ffec83 50%,
                    #ffffff 100%);
                background-blend-mode: normal, normal;
                font-weight: bold;
            }
        }

    }

    .echarts {
        width: 100%;
        height: 100%;
        background: transparent;
    }

    .map {
        background: url(../../../assets/img/data/bg_map.png) no-repeat top;
        background-size: 100% 100%;
    }

    .dv-border-box-10 {
        box-shadow: #fa9d1b55 0px 0px 0px 1px inset !important;
    }
}
</style>
